import './DataTableV2GanttChartCell.css';
export var ganttChartCellCSS = '_19w1oxi0-2-0-1';
export var ganttChartDefaultCellCSS = '_19w1oxi1-2-0-1';